import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function fmtDate(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function fmtTime(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return iso;
  }
}

export function statusColor(state) {
  const s = (state || '').toLowerCase();
  if (['open', 'connected', 'sent', 'done'].includes(s)) return 'text-emerald-400';
  if (['connecting', 'pending', 'running'].includes(s)) return 'text-amber-400';
  if (['close', 'closed', 'failed', 'error', 'disconnected', 'cancelled'].includes(s)) return 'text-red-400';
  return 'text-zinc-400';
}

export function normalizePhone(raw) {
  if (!raw) return '';
  return raw.replace(/\D/g, '');
}

export function parsePhoneList(raw) {
  if (!raw) return [];
  return raw
    .split(/[\s,;\n]+/)
    .map((x) => normalizePhone(x))
    .filter((x) => x.length >= 8);
}

export function shortJid(jid) {
  if (!jid) return '';
  return jid.replace('@g.us', '').replace('@s.whatsapp.net', '');
}

export function apiErrorMessage(error, fallback = 'Erro inesperado') {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((item) => item?.msg || item?.message || JSON.stringify(item))
      .filter(Boolean)
      .join(' · ');
  }
  if (detail && typeof detail === 'object') {
    return detail.response?.message || detail.message || JSON.stringify(detail);
  }
  if (typeof error?.response?.data === 'string') return error.response.data.slice(0, 240);
  return error?.message || fallback;
}
